const calculateElements = (heightThresholds: number[], defaultElements: number) => {
  const index = heightThresholds.findIndex((threshold) => window.innerHeight < threshold)
  return index !== -1 ? index + 2 : defaultElements
}

export default calculateElements
